module.exports = __webpack_public_path__ + "img/Certificate_1.6f4a97e1.jpg";